export const initiateCall = (phoneNumber: string, win: Window = window): void => {
  if (!phoneNumber) {
    console.error('Phone number is missing.');
    return;
  }
  const cleanNumber = phoneNumber.replace(/[^0-9+]/g, '');
  win.location.href = `tel:${cleanNumber}`;
};
